import React from 'react'
import { useIsMobile } from "../../../utils/hooks/useIsMobile";
import AppBarCommon from '../../../molecules/app-bar-common';
import { Box } from '@mui/material';
const CompanyInfoHeader = () => {
    const isMobile = useIsMobile();
    return (
        <Box sx={{ pb: isMobile ? "0" : "5px" }}>
            <AppBarCommon
                title={"Company Info"}
                isSearch={false}
                isUserIcon
                isIconDefine={false}
            />
        </Box>
    )
}

export default CompanyInfoHeader